import React from "react";

const Preloader = () => {
  require("./utils.css");
  return (
    
    <div
      className="preloader"
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="lds-ripple">
        <div className="lds-pos"></div>
        <div className="lds-pos"></div>
      </div>
    </div>
  );
};

export default Preloader;
